import {
  handleKeyDown,
  getBuyer,
  getItem,
  updatePurchase,
  createStorePurchase,
  getSinglePurches,
} from "_services";

import { CommonDate, CommonInput, CustomSelect, Heading } from "components";
import { BasicExample } from "components/common/CommonModal/CommonModal";
import { errorSchema, utils } from "helper";
import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import { Images } from "constants";
import { AttachedFileModal } from "modals";
const AddPurchase = () => {
  const initi = {
    buyer: "",
    purchase_date: new Date(),
    purchase_bill_number: "",
  };

  const itemObj = {
    item_id: "",
    quantity: 0,
    
  };

  const navigate = useNavigate();
  const { id, eventView } = useParams();
  const eventRef = useRef(null);
  const mobileRef = useRef(null);
  const nameRef = useRef(null);
  const genderRef = useRef(null);
  const stateRef = useRef(null);
  const [form, setForm] = useState(initi);
  const [initialForm, setInitialForm] = useState(initi);
  const [formError, setFormError] = useState("");
  const [allBuyerList, setAllBuyerList] = useState([]);
  const [allItemList, setAllItemList] = useState([]);
  const [itemList, setItemList] = useState([itemObj]);
  const [initialItemList, setInitialItemList] = useState([itemObj]);
  const [isLoading, setIsLoading] = useState(false);
 const [selectedItems, setSelectedItems] = useState({});
  //   useEffect(() => {
  //     if (mobileRef.current) {
  //       nameRef.current.focus();
  //     }
  //   }, []);

  useEffect(() => {
    getBuyerList();
    getItemList();
  }, []);

  useEffect(() => {
    if (id) {
      getPurchaseDetails(id);
    }
  }, [id]);

 

  const getPurchaseDetails = async (id) => {
    try {
      const res = await getSinglePurches(id);
      if (res?.status === 200) {
        
        const eventData = {
          buyer: res?.results?.buyer,
          purchase_date: res?.results?.purchase_date,
          purchase_bill_number: res?.results?.purchase_bill_number,
        };
        const list = res?.results?.purchase_items?.map((i) => {
          return {
            item_id: i?.item,
            quantity: i?.quantity,
            cost_per_item: i?.cost_per_item,
          };
        });
        setSelectedItems(res?.results?.purchase_items?.map((i)=>i?.item))
        setItemList(list);
        setForm(eventData);
        setInitialForm(eventData);
      }
    } catch (error) {}
  };

  const getBuyerList = async (url = "") => {
    try {
      const buyerFilter = {
        limit:"all"
      }
      const filterParams = new URLSearchParams();
      Object.keys(buyerFilter).forEach((key) => {
        if (buyerFilter[key]) {
          filterParams.append(key, buyerFilter[key]);
        }
      });

      const urlmodify = `${url}?${filterParams.toString()}`;
      const res = await getBuyer(url,filterParams.toString());

      if (res?.status === 200) {
        const list = res?.results?.map((i) => {
          return {
            ...i,
            label: i?.name,
            value: i?.id,
          };
        });
        setAllBuyerList(list);
      } else {
        toast.error(res.error);
      }
    } catch (error) {
      toast.error(error);
    } finally {
    }
  };

  const getItemList = async (url = "") => {
    try {
      const buyerFilter = {
        limit:"all"
      }
      const filterParams = new URLSearchParams();
      Object.keys(buyerFilter).forEach((key) => {
        if (buyerFilter[key]) {
          filterParams.append(key, buyerFilter[key]);
        }
      });

      const urlmodify = `${url}?${filterParams.toString()}`;
      const res = await getItem(url,filterParams.toString());

      if (res?.status === 200) {
        const list = res?.results?.map((i) => {
          return {
            ...i,
            label: i?.name,
            value: i?.id,
          };
        });
        setAllItemList(list);
      } else {
        toast.error(res.error);
      }
    } catch (error) {
      toast.error(error);
    } finally {
    }
  };

  const handleOnChange = async (name, value) => {
    setForm((prevForm) => {
      const updatedForm = {
        ...prevForm,
        [name]: value,
      };

      if (formError) {
        utils
          .checkFormError(
            {
              ...updatedForm,
            },
            errorSchema.purchaseSchema
          )
          .then((validationResult) => {
            if (validationResult === true) {
              setFormError("");
            } else {
              setFormError(validationResult);
            }
          });
      }

      return updatedForm;
    });
  };

  const convertToISOFormat = (dateString) => {
    const date = new Date(dateString);
    return date.toISOString();
  };

  const handleSubmit = async () => {
    try {
      // Validate form and return if errors are present
      const validationResult = await utils?.checkFormError(
        { ...form, itemArray: itemList },
        errorSchema.purchaseSchema
      );

      if (validationResult !== true) {
        setFormError(validationResult);
        return;
      }

      const changedPayload = buildChangedPayload();

      if (Object.keys(changedPayload).length === 0) {
        console.log("No changes detected.");
        return;
      }

      setIsLoading(true);

      // Submit booking update or creation
      if (Object.keys(changedPayload).length !== 0) {
        const bookingResponse = id
          ? await updatePurchase({ payload: { ...form, items: itemList }, id })
          : await createStorePurchase(changedPayload);

        handleBookingResponse(bookingResponse);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Submission error:", error);
    }
  };

  // Helper function to build changed payload for booking details
  const buildChangedPayload = () => {
    const payload = {};

    const fieldsToCheck = ["buyer", "purchase_date", "purchase_bill_number"];
    fieldsToCheck.forEach((field) => {
      if (form[field] !== initialForm[field]) {
        payload[field] = form[field];
      }
      payload.items = itemList;
      payload.purchase_date = utils.formatDate(form?.purchase_date);
    });

    return payload;
  };

  const handleBookingResponse = (response) => {
    setIsLoading(false);
    if (response?.status === 200 || response?.status === 201) {
      toast.success(response.message);
      navigate("/store/purchase");
    } else {
      
    }
  };

  const handleKey = (e, nextInputRef) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (nextInputRef && nextInputRef.current) {
        nextInputRef.current.focus();
      } else {
        handleSubmit(e);
      }
    } else if (e.key === "ArrowUp" || e.key === "ArrowDown") {
      e.preventDefault();
    }
  };

  const addItemInput = (e) => {
    e.preventDefault();

    setItemList((preState) => {
      return [...preState, itemObj];
    });
  };

  const removeFromInput = (index) => {
    const newItemIput = [...itemList];
    newItemIput.splice(index, 1);
    setItemList(newItemIput);
  };

  const handleInputChange = async (value, index, name) => {
    const newItem = [...itemList];
    newItem[index][name] = value;
    setItemList(newItem);
    setSelectedItems((prevSelected) => ({
      ...prevSelected,
      [index]: value, 
    }));

    if (formError) {
      if (`${formError}${[index]}${[name]}`) {
        const validationResult = await utils.checkFormError(
          { ...form, itemArray: itemList },
          errorSchema.purchaseSchema
        );

        if (validationResult === true) {
          const newFormError = { ...formError };
          if (newFormError.itemArray && newFormError.itemArray[index]) {
            delete newFormError.itemArray[index][name];
            if (Object.keys(newFormError.itemArray[index]).length === 0) {
              delete newFormError.itemArray[index];
            }
          }
          setFormError(newFormError);
        } else {
          setFormError(validationResult);
        }
      }
    }
  };

  return (
    <div>
      <Heading title={id ? "Edit Purchase" : "Add Purchase"} />
      <div className="_addContainer bg-[#FBF9FB]">
        <div className="_midCont_body">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12 col-lg-12 col-xl-10">
                <div className="_crtDisp_listBx">
                  <div className="">
                    <h4 className="_disPatch_heads">Buyer Details</h4>
                    <div className="_fleX_inds">
                      <div className="_divForth">
                        <CustomSelect
                          placeholder="Select Buyer"
                          label="Buyer"
                          options={allBuyerList}
                          onSelect={(data) => {
                            handleOnChange("buyer", data.value);
                          }}
                          focus={
                            !!(
                              typeof formError === "object" && formError?.buyer
                            )
                          }
                          error={
                            !!(typeof formError === "object")
                              ? formError?.buyer
                              : ""
                          }
                          value={allBuyerList?.find(
                            (i) => i?.id === form?.buyer
                          )}
                          ref={eventRef}
                          enableSearch={true}
                          // onEnterSelect={() => mobileRef.current.focus()}
                          disabled={eventView}
                        />
                      </div>
                      <div className="_divForth">
                        <CommonDate
                          name="date"
                          label="Purchase Date"
                          startDate={form.purchase_date}
                          setStartDate={(data) => {
                            handleOnChange("purchase_date", data);
                          }}
                          error={formError?.purchase_date}
                          focus={!!formError?.purchase_date}
                          onEnterKey={handleSubmit}
                          // disabled={
                          //   id
                          //     ? !initialForm?.check_out
                          //       ? false
                          //       : true
                          //     : false
                          // }
                          ref={mobileRef}
                          disabled={eventView}
                        />
                      </div>
                      {/* <div className="_divForth">
                        <CommonInput
                          type="text"
                          placeholder="Enter Purchase bill number"
                          label="Purchase Bill Number"
                          name="purchase_bill_number"
                          value={form?.purchase_bill_number}
                          focus={
                            !!(
                              typeof formError === "object" &&
                              formError?.purchase_bill_number
                            )
                          }
                          error={
                            !!(typeof formError === "object")
                              ? formError?.purchase_bill_number
                              : ""
                          }
                          onChange={({ target: { name, value } }) =>
                            handleOnChange(name, value)
                          }
                          ref={nameRef}
                          // onKeyDown={(e) => handleKey(e, genderRef)}
                          disabled={eventView}
                        />
                      </div> */}
                    </div>
                  </div>
                  <div className="">
                    <h4 className="_disPatch_heads">Items Details</h4>
                    <div className="_fleX_inds">
                      {itemList?.map((data, index) => {
                        return (
                          <>
                            <div className="_divForth">
                              <CustomSelect
                                placeholder="Select Item"
                                label="Item"
                                // options={allItemList}
                                options={allItemList.filter(
                                  (item) => !Object.values(selectedItems).includes(item.value) // Remove all selected values
                                )}
                                onSelect={(data) => {
                                  handleInputChange(
                                    data?.value,
                                    index,
                                    "item_id"
                                  );
                                }}
                                focus={formError[`itemArray[${index}].item_id`]}
                                error={formError[`itemArray[${index}].item_id`]}
                                value={
                                  data?.item_id
                                    ? allItemList?.find(
                                        (i) => i?.value === data?.item_id
                                      )
                                    : { label: "", value: "" }
                                }
                                ref={genderRef}
                                enableSearch={true}
                                // onEnterSelect={() => stateRef.current.focus()}
                                disabled={eventView}
                              />
                            </div>
                            <div className="_divForth">
                              <CommonInput
                                type="text"
                                placeholder="Enter Quantity"
                                label="Quantity"
                                name="quantity"
                                // borderStyle={"borderStyle"}
                                value={data?.quantity}
                                focus={
                                  formError[`itemArray[${index}].quantity`]
                                }
                                error={
                                  formError[`itemArray[${index}].quantity`]
                                }
                                onChange={({ target: { name, value } }) => {
                                  handleInputChange(value, index, name);
                                }}
                                // ref={mobileRef}
                                // onKeyDown={(e) => handleKey(e, nameRef)}
                                disabled={eventView}
                                onKeyPress={handleKeyDown}
                              />
                            </div>
                            <div className="_divForth">
                            {itemList?.length > 1 && (
                                <div
                                  className="delete_btn"
                                  onClick={() => removeFromInput(index)}
                                >
                                  <div className="_listbtn">
                                    {" "}
                                    <button
                                      className="_del_pl"
                                      onClick={() => removeFromInput(index)}
                                      disabled={eventView}
                                    >
                                      <img
                                        src={Images.DELETEICON.default}
                                        alt=""
                                      />
                                    </button>
                                  </div>
                                </div>
                              )}
                              {/* <CommonInput
                                type="text"
                                placeholder="Enter Cost Per Item"
                                label="Cost Per Item"
                                name="cost_per_item"
                                // borderStyle={"borderStyle"}
                                value={data?.cost_per_item}
                                focus={
                                  formError[`itemArray[${index}].cost_per_item`]
                                }
                                error={
                                  formError[`itemArray[${index}].cost_per_item`]
                                }
                                onChange={({ target: { name, value } }) => {
                                  handleInputChange(value, index, name);
                                }}
                                ref={mobileRef}
                                // onKeyDown={(e) => handleKey(e, nameRef)}
                                disabled={eventView}
                                onKeyPress={handleKeyDown}
                              /> */}
                            </div>
                            <div className="_divForth">
                              
                            </div>
                          </>
                        );
                      })}

                      <div className="_divForth">
                        <div
                          className="_anvSwitcherNew form-check form-switch add_btn"
                          style={{ width: "150px", marginTop: "10px" }}
                        >
                          <div className="_listbtn">
                            <button
                              className="_addComm_btn _builtyPrintBtn"
                              onClick={addItemInput}
                              disabled={eventView}
                            >
                              + Add
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bottomFix">
        <button
          className="_addComm_btn"
          type="button"
          onClick={() => handleSubmit()}
          disabled={isLoading || eventView}
        >
          {isLoading ? (
            <BasicExample />
          ) : id ? (
            "Update Purchase"
          ) : (
            "Add Purchase"
          )}
        </button>
      </div>
    </div>
  );
};

export default AddPurchase;

export const MessageModal = ({ show, onClose, title, message }) => {
  if (!show) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-box">
        {title && <h3>{title}</h3>}
        <p>{message}</p>
        {onClose && <button onClick={onClose}>Close</button>}
      </div>
    </div>
  );
};
